// Unpublished Work © 2021-2025 Deere & Company.

import t from 'tcomb';
import {CustomerDetails} from './customer-details';

export const AddCustomer = t.struct({
    allowedCustomerTypeForNewAdds: t.maybe(t.String),
    prefilledCustomerDetails: CustomerDetails
}, {
    defaultProps: {
        allowedCustomerTypeForNewAdds: '',
        prefilledCustomerDetails: CustomerDetails({})
    },
    name: 'AddCustomer',
    strict: true
});
